import type { MisconceptionDefinition } from './types'

import { cijferenVolgordeMisconceptions } from './rek/cijferenVolgorde'
import { contextStrategieBasisMisconceptions } from './rek/contextStrategieBasis'
import { schattenBasisMisconceptions } from './rek/schattenBasis'
import { cijferOperatiesMisconceptions } from './rek/cijferOperaties'
import { contextMeerstapsMisconceptions } from './rek/contextMeerstaps'
import { schattenRonde2Misconceptions } from './rek/schattenRonde2'

/**
 * REK — Basisrekenen misconcepties (barrel).
 *
 * Deze barrel concateneert zes sub-registries onder `./rek/`:
 * - `cijferenVolgorde`
 * - `contextStrategieBasis`
 * - `schattenBasis`
 * - `cijferOperaties`
 * - `contextMeerstaps`
 * - `schattenRonde2`
 */
export const REK_MISCONCEPTIONS: MisconceptionDefinition[] = [
  ...cijferenVolgordeMisconceptions,
  ...contextStrategieBasisMisconceptions,
  ...schattenBasisMisconceptions,
  ...cijferOperatiesMisconceptions,
  ...contextMeerstapsMisconceptions,
  ...schattenRonde2Misconceptions,
]
